module.exports = __webpack_public_path__ + "static/AccompanimentLogistics-d24e578c75eb3979e97ffcebf9cd3b82.png";